<template>
  <div
    class="grid-games"
    v-infinite-scroll="loadMoreGames"
    infinite-scroll-throttle-delay="500"
    :infinite-scroll-disabled="busy"
    :infinite-scroll-distance="10"
  >
    <div v-for="(game, i) in gameList" :key="i" @click="initGame(game)">
      <GameData :game="game" :type="type" @removeItem="removeGame" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import GameData from "./GameData.vue";

export default {
  props: ["searchText", "type", "selectedProviders"],
  components: {
    GameData,
  },
  data: () => ({
    meta: {
      limit: 20,
      offset: 0,
    },
    gameCount: 0,
    busy: false,
    searchTime: null,
    gameList: [],
    selected_providers: [],
  }),
  watch: {
    searchText() {
      this.replaceUrl();
      if (this.searchTime) {
        clearTimeout(this.searchTime);
        this.searchTime = null;
      }
      this.searchTime = setTimeout(async () => {
        await this.loadMoreGames(true, true);
        clearTimeout(this.searchTime);
      }, 500);
    },
    async selectedProviders() {
      this.selected_providers = this.selectedProviders;
      await this.loadMoreGames(false, true);
    },
    "$route.query.providers": {
      handler() {
        if (!this.$route.query.providers) {
          this.selected_providers = [];
        } else {
          this.selected_providers = this.$route.query.providers.split(",");
        }
        this.loadMoreGames(false, true);
      },
    },
  },
  async mounted() {
    const providers = this.$route.query.providers || "";
    providers.split(",").map((provider) => {
      this.selected_providers.push(provider);
    });
    this.selected_providers = this.selected_providers.filter((provider) => !!provider);
  },
  computed: {
    getFilters() {
      switch (this.$route.name) {
        case "Slots":
          return ["slots"];
        case "LiveCasino":
          return ["live"];
        case "Home":
          return ["all"];
        default:
          return ["all"];
      }
    },
  },
  methods: {
    ...mapActions("game", ["getGames", "getFavoriteGames", "getRecentGames", "gameInit", "getGameByName", "sortGames"]),
    ...mapMutations("user", ["setShowLogin"]),
    async loadMoreGames(loadmore = true, isSearch = false) {
      if (!this.busy && this.gameCount >= this.meta.offset && this.gameList) {
        this.busy = true;
        try {
          await this.fetchGames(loadmore, isSearch);
        } catch (err) {}
        this.busy = false;
      }
    },
    async fetchGames(loadMore = false, isSearch = false) {
      let response = null;
      if (this.type == "favorites") {
        response = await this.getFavoriteGames({
          filterTypes: this.getFilters,
          limit: this.meta.limit,
          offset: loadMore && !isSearch ? this.meta.offset : 0,
          isMobile: this.$device.mobile,
          providers: this.selected_providers,
          type: this.$route.name.toLowerCase(),
          search: this.searchText,
        });
        if (!loadMore) {
          this.gameList = response.rows;
        } else this.reloadGames(response.rows, isSearch);
      } else if (this.type == "recent-games") {
        response = await this.getRecentGames({
          filterTypes: this.getFilters,
          limit: this.meta.limit,
          isMobile: this.$device.mobile,
          offset: loadMore && !isSearch ? this.meta.offset : 0,
          providers: this.selected_providers,
          type: this.$route.name.toLowerCase(),
          search: this.searchText,
        });
        if (!loadMore) this.gameList = response.rows;
        else this.reloadGames(response.rows, isSearch);
      } else {
        response = await this.getGames({
          filterTypes: this.getFilters,
          limit: this.meta.limit,
          isMobile: this.$device.mobile,
          offset: loadMore && !isSearch ? this.meta.offset : 0,
          providers: this.selected_providers,
          type: this.$route.name.toLowerCase(),
          search: this.searchText,
        });
        if (!loadMore) {
          this.gameList = response.rows;
        } else this.reloadGames(response.rows, isSearch);
      }

      this.gameCount = response && (response.count || 0);
      this.meta.offset = this.gameCount > 0 ? this.meta.offset + (response && (response.length || 0)) : 0;
      if (this.meta.offset > this.gameCount) this.meta.offset = this.gameCount;
    },
    async reloadGames(games, isSearch = false) {
      if (isSearch) return (this.gameList = games);
      this.gameList = [...this.gameList, ...games];
    },
    replaceUrl() {
      if (this.searchText != this.$route.query.q) {
        let query = {
          ...this.$route.query,
          q: this.searchText,
        };
        if (!this.searchText) {
          delete query.q;
        }
        this.$router.replace({
          query,
        });
      }
    },
    removeGame(game) {
      this.gameList = this.gameList.filter((g) => g.id != game.id);
      this.meta.offset -= 1;
    },
    async initGame(game) {
      if (!this.$auth.user) {
        return this.setShowLogin(true);
      }

      const type = game.game_type != "slots" ? "real-live" : "real-slots";
      if (type.includes("live")) {
        this.$router.push({
          name: "Play",
          params: { type, id: game.id },
        });
      } else {
        this.$router.push({
          name: "Play",
          params: { type, id: game.id },
        });
      }
    },
  },
};
</script>
